"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useApollo = exports.addApolloState = exports.initializeApollo = exports.APOLLO_STATE_PROP_NAME = void 0;
var react_1 = require("react");
var client_1 = require("@apollo/client");
var error_1 = require("@apollo/client/link/error");
var deepmerge_1 = __importDefault(require("deepmerge"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var apollo_upload_client_1 = require("apollo-upload-client");
var context_1 = require("@apollo/client/link/context");
var react_2 = require("next-auth/react");
exports.APOLLO_STATE_PROP_NAME = "__APOLLO_STATE__";
var apolloClient;
var errorLink = (0, error_1.onError)(function (_a) {
    var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
    if (graphQLErrors)
        graphQLErrors.forEach(function (_a) {
            var message = _a.message, locations = _a.locations, path = _a.path;
            return console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
        });
    if (networkError)
        console.log("[Network error]: ".concat(networkError));
});
var authLink = (0, context_1.setContext)(function (_, _a) {
    var headers = _a.headers;
    return __awaiter(void 0, void 0, void 0, function () {
        var session, token;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, react_2.getSession)()];
                case 1:
                    session = _b.sent();
                    token = session === null || session === void 0 ? void 0 : session.accessToken;
                    return [2 /*return*/, {
                            headers: __assign(__assign({}, headers), { Authorization: token ? "JWT ".concat(token) : "" })
                        }];
            }
        });
    });
});
var httpLink = (0, apollo_upload_client_1.createUploadLink)({
    uri: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT,
    credentials: "same-origin"
});
function createApolloClient() {
    var links = [errorLink, httpLink];
    if (process.env.NEXTAUTH_URL) {
        links.push(authLink);
    }
    if (!process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT) {
        throw new Error("NEXT_PUBLIC_GRAPHQL_ENDPOINT is not defined");
    }
    return new client_1.ApolloClient({
        ssrMode: typeof window === "undefined",
        link: (0, client_1.from)(links),
        cache: new client_1.InMemoryCache()
    });
}
function initializeApollo(initialState) {
    if (initialState === void 0) { initialState = null; }
    var _apolloClient = apolloClient !== null && apolloClient !== void 0 ? apolloClient : createApolloClient();
    // If your page has Next.js data fetching methods that use Apollo Client, the initial state
    // gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        var existingCache = _apolloClient.extract();
        // Merge the initialState from getStaticProps/getServerSideProps in the existing cache
        var data = (0, deepmerge_1["default"])(existingCache, initialState, {
            // combine arrays using object equality (like in sets)
            arrayMerge: function (destinationArray, sourceArray) { return __spreadArray(__spreadArray([], sourceArray, true), destinationArray.filter(function (d) { return sourceArray.every(function (s) { return !(0, lodash_isequal_1["default"])(d, s); }); }), true); }
        });
        // Restore the cache with the merged data
        _apolloClient.cache.restore(data);
    }
    // For SSG and SSR always create a new Apollo Client
    if (typeof window === "undefined")
        return _apolloClient;
    // Create the Apollo Client once in the client
    if (!apolloClient)
        apolloClient = _apolloClient;
    return _apolloClient;
}
exports.initializeApollo = initializeApollo;
function addApolloState(client, pageProps) {
    if (pageProps === null || pageProps === void 0 ? void 0 : pageProps.props) {
        pageProps.props[exports.APOLLO_STATE_PROP_NAME] = client.cache.extract();
    }
    return pageProps;
}
exports.addApolloState = addApolloState;
function useApollo(pageProps) {
    var state = pageProps[exports.APOLLO_STATE_PROP_NAME];
    var store = (0, react_1.useMemo)(function () { return initializeApollo(state); }, [state]);
    return store;
}
exports.useApollo = useApollo;
